import { UPDATETEMPLATESTATUS_SUCCESS, UPDATETEMPLATESTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateTemplateStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATETEMPLATESTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATETEMPLATESTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateTemplateStatusReducer;
